import $ from 'jquery';

const company = element => {
    uniteLabels(element);
    bindTabSwitcher(element);
};

const uniteLabels = element => {
    const $labels = element.find('.company__attribute label');

    let desiredWidth = 0;

    $(() => {
        $labels.each(function () {
            const $thisWidth = $(this).width();

            if ($thisWidth > desiredWidth) {
                desiredWidth = $thisWidth;
            }
        });

        $labels.css('width', desiredWidth + 'px');
    });
};

const bindTabSwitcher = element => {
    const $tabSwitcher = element.find('.company__tab-switcher');

    $tabSwitcher.off('click');
    $tabSwitcher.on('click', function () {
        const $thisEl = $(this);

        element.find('.company__tab-switcher--active').removeClass('company__tab-switcher--active');
        $thisEl.addClass('company__tab-switcher--active');

        const $activeTab = element.find('.company__tab--active');
        const $nextActiveTab = element.find(
            '.company__tab[data-tab="' + $thisEl.data('tab') + '"]'
        );

        $activeTab
            .removeClass('company__tab--active')
            .one('transitionend', () =>
                $activeTab.hide(0, () =>
                    $nextActiveTab.show(0, () => $nextActiveTab.addClass('company__tab--active'))
                )
            );
    });
};

export const reloadScriptCompany = () => {
    const $company = $('.company');

    $company.each(function (index) {
        company($(this), index);
    });
};
reloadScriptCompany();
